export const CompanyDocumentGroup = {
  FinancialReports: 'financial_reports',
  Wallets: 'wallets',
  Legal: 'legal',
  BodReports: 'bod_reports',
  Other: 'other',
} as const;

export const CompanyDocumentType = {
  BudgetPlan: 'budget_plan',
  PnlStatement: 'pnl_statement',
  FinanceWallets: 'finance_wallets',
} as const;
